// Production site URL — used to build absolute URLs for OG/Twitter/canonical tags.
// Social validators (Facebook, Twitter, LinkedIn, OpenGraph.xyz) require absolute URLs.
export const SITE_URL = "https://www.amr3designconstruction.com";

/** Google Business Profile (Maps listing) for AMR 3 Design & Construction LLC. */
export const GOOGLE_BUSINESS_PROFILE_URL = "https://www.google.com/maps?cid=6621967010212129613";

/** Build an absolute URL for OG/canonical tags. Pass a path starting with "/". */
export function absUrl(path: string = "/"): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
